export default {
    buttonsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        padding: "20px 8px"
    }
}